module.exports = __webpack_public_path__ + "img/logo.b15b9d6b.png";